export const getApiVersionHeader = (version: string = '1.0') => ({
  Accept: `application/json;api-version=${version}`,
});
